/**
 * REDEX Service Add-ons
 * Optional upsell products for service tiers
 */

export interface ServiceAddOn {
  id: string;
  name: string;
  description: string;
  price: number; // Price in cents
  priceId: string; // Stripe price ID
  type: 'recurring' | 'one_time';
  category: 'leads' | 'automation' | 'credits' | 'services';
  popular?: boolean;
  compatibleTiers?: string[]; // If empty, compatible with all
}

export const SERVICE_ADD_ONS: ServiceAddOn[] = [
  {
    id: 'additional_leads_50',
    name: 'Additional 50 Leads/Week',
    description: 'Boost your pipeline with 50 more qualified leads per week',
    price: 19999, // $199.99/month
    priceId: 'price_1ScWTnAmx3PBCGtX7WIlDoFO',
    type: 'recurring',
    category: 'leads',
    popular: true,
    compatibleTiers: ['starter', 'professional', 'growth'],
  },
  {
    id: 'linkedin_automation',
    name: 'LinkedIn Automation Pro',
    description: 'Advanced LinkedIn outreach with connection requests and InMail automation',
    price: 14999, // $149.99/month
    priceId: 'price_1ScWTnAmx3PBCGtXP5RSCP9J',
    type: 'recurring',
    category: 'automation',
    popular: true,
    compatibleTiers: ['starter', 'professional'],
  },
  {
    id: 'sms_credits_1000',
    name: '1,000 SMS Credits',
    description: 'One-time purchase of 1,000 SMS message credits',
    price: 9900, // $99.00
    priceId: 'price_1ScWToAmx3PBCGtX1Wdhq0es',
    type: 'one_time',
    category: 'credits',
  },
  {
    id: 'custom_integration',
    name: 'Custom Integration Setup',
    description: 'One-time setup fee for custom CRM or tool integration',
    price: 50000, // $500.00
    priceId: 'price_1ScWToAmx3PBCGtXGdD5zscb',
    type: 'one_time',
    category: 'services',
  },
  {
    id: 'consulting_hour',
    name: 'Strategy Consulting Hour',
    description: 'One hour of expert sales strategy consulting',
    price: 25000, // $250.00
    priceId: 'price_1ScWToAmx3PBCGtXPfKtQR8A',
    type: 'one_time',
    category: 'services',
  },
];

// Helper functions
export function getAddOn(addOnId: string): ServiceAddOn | undefined {
  return SERVICE_ADD_ONS.find(a => a.id === addOnId);
}

export function getAddOnsForTier(tierId: string): ServiceAddOn[] {
  return SERVICE_ADD_ONS.filter(
    a => !a.compatibleTiers || a.compatibleTiers.includes(tierId)
  );
}

export function getPopularAddOns(): ServiceAddOn[] {
  return SERVICE_ADD_ONS.filter(a => a.popular);
}

export function formatAddOnPrice(addon: ServiceAddOn): string {
  const price = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: addon.price % 100 === 0 ? 0 : 2,
  }).format(addon.price / 100);
  
  return addon.type === 'recurring' ? `${price}/mo` : price;
}
